import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "aggregation_min",
  "use": "aggregation_min-usage",
  "viewBox": "0 0 15 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 15 16\" id=\"aggregation_min\"><path d=\"M10.03 6.97a.754.754 0 0 0-1.06 0c-.29.29-.29.77 0 1.06l2.47 2.47H4.71c-1.77 0-3.21-1.44-3.21-3.21V0H0v7.29C0 9.89 2.11 12 4.71 12h6.23l-1.97 1.97c-.29.29-.29.77 0 1.06.15.15.34.22.53.22s.38-.07.53-.22L14.06 11z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol